import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTFormData, TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'

const multiInputs: (keyof IELTFormData)[] = [
  'LastEngagement',
  'MeetingPurpose',
  'LongTermPriorities',
  'ShortTermPriorities',
  'SupportingPriorities',
  'NeedSupport',
  'FinancialPerformance',
  'GoodNewsDesc',
  'Issues',
  'BalanceOfTradeSummary',
]

const getMultiInputsDataWithoutEmptyRows = (formData: TEltFormData) => {
  const multiInputsDataWithoutEmptyRows = {}
  for (const key of Object.keys(formData)) {
    if (multiInputs.includes(key as keyof IELTFormData)) {
      multiInputsDataWithoutEmptyRows[key] = formData[key].filter((el: string) => el)
    }
  }
  return multiInputsDataWithoutEmptyRows
}

export const removeEmptyRows = (formData: TEltFormData, eltType: EltType = EltType.Pptx) => {
  if (isDocType(eltType)) {
    const multiInputsDataWithoutEmptyRows = getMultiInputsDataWithoutEmptyRows(formData)
    return {
      ...formData,
      ...multiInputsDataWithoutEmptyRows,
    }
  }

  const pptxFormData = formData as IELTFormData
  const notEmptyHpAttendees =
    pptxFormData.HpAttendees?.filter((el) => el.Name || el.Email || el.Title) || []
  const notEmptyAccountAttendees =
    pptxFormData.AccountAttendees?.filter((el) => el.Name || el.Email || el.Title) || []
  const notEmptyAgenda =
    pptxFormData.MeetingAgenda?.filter((el) => el.Topic || el.Time || el.Presenter) || []
  const notEmptyKeyOpportunities =
    pptxFormData.KeyOpportunities?.filter((el) => el.TopDeal || el.TotalUSD || el.CloseDate) || []
  const multiInputsDataWithoutEmptyRows = getMultiInputsDataWithoutEmptyRows(formData)
  return {
    ...formData,
    HpAttendees: notEmptyHpAttendees,
    AccountAttendees: notEmptyAccountAttendees,
    MeetingAgenda: notEmptyAgenda,
    KeyOpportunities: notEmptyKeyOpportunities,
    ...multiInputsDataWithoutEmptyRows,
  }
}
